<template>
  <div class="print-container">
    <div class="header">정기 근골격계 유해요인 조사 증상조사표 통계(2025)</div>
    <div class="sub-header">- 환경사업소(응답인원 : 6명) -</div>

    <div class="mt-4 grid gap-4" style="grid-template-columns: 1fr 1fr 1fr">
      <div>
        <div class="content-label">성별</div>
        <page-chart-table :data-list="chartData.성별데이터" :total="chartData.성별인원" />
      </div>

      <div>
        <div class="content-label">결혼여부</div>
        <page-chart-table :data-list="chartData.결혼데이터" :total="chartData.결혼인원" />
      </div>

      <div>
        <div class="content-label">기본정보(평균)</div>
        <table>
          <thead>
          <tr>
            <th>구분</th>
            <th>인원</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in chartData.기본정보데이터" :key="index">
            <td>{{ item.구분 }}</td>
            <td>{{ item.평균 }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="mt-4 grid gap-4 items-center" style="grid-template-columns: 1fr 1fr">
      <div>
        <div class="content-label">1. 여가 및 취미활동</div>
        <page-chart-table :data-list="chartData.여가및취미활동데이터" :total="chartData.여가및취미활동인원" />
      </div>
      <div>
        <BasicPieChart :value="chartData.여가및취미활동데이터"
                       labelField="구분" valueField="점유율" :height="150"
                       :show-data-labels="false" :legend-width="330" />
      </div>
    </div>

    <div class="mt-4 grid gap-4 items-center" style="grid-template-columns: 1fr 1fr">
      <div>
        <div class="content-label">2. 하루 평균 가사 노동시간</div>
        <page-chart-table :data-list="chartData.하루평균가사노동시간데이터" :total="chartData.하루평균가사노동시간인원" />
      </div>
      <div>
        <BasicPieChart :value="chartData.하루평균가사노동시간데이터"
                       labelField="구분" valueField="점유율" :height="150"
                       :show-data-labels="false" :legend-width="330" />
      </div>
    </div>

    <div class="mt-4 grid gap-4 items-center" style="grid-template-columns: 1fr 1fr">
      <div>
        <div class="content-label">3. 질병 진단 여부</div>
        <page-chart-table :data-list="chartData.질병진단여부데이터" :total="chartData.질병진단여부인원" />
      </div>
      <div>
        <BasicPieChart :value="chartData.질병진단여부데이터"
                       labelField="구분" valueField="점유율" :height="150"
                       :show-data-labels="false" :legend-width="330" />
      </div>
    </div>

    <div class="mt-4 grid gap-4 items-center" style="grid-template-columns: 1fr 1fr">
      <div>
        <div class="content-label">3.1 현재 상태</div>
        <page-chart-table :data-list="chartData.질병_현재상태데이터" :total="chartData.질병_현재상태인원" />
      </div>
      <div>
        <BasicPieChart :value="chartData.질병_현재상태데이터"
                       labelField="구분" valueField="점유율" :height="150"
                       :show-data-labels="false" :legend-width="330" />
      </div>
    </div>
    <div class="mt-4 grid gap-4 items-center" style="grid-template-columns: 1fr 1fr">
      <div>
        <div class="content-label">3.2 질병명</div>
        <page-chart-table :data-list="chartData.질병_질병명데이터" :total="chartData.질병_질병명인원" />
      </div>
      <div>
        <BasicPieChart :value="chartData.질병_질병명데이터"
                       labelField="구분" valueField="점유율" :height="150"
                       :show-data-labels="false" :legend-width="330" />
      </div>
    </div>
    <div class="mt-4 grid gap-4 items-center" style="grid-template-columns: 1fr 1fr">
      <div>
        <div class="content-label">4. 사고 여부</div>
        <page-chart-table :data-list="chartData.사고여부데이터" :total="chartData.사고여부인원" />
      </div>
      <div>
        <BasicPieChart :value="chartData.사고여부데이터"
                       labelField="구분" valueField="점유율" :height="150"
                       :show-data-labels="false" :legend-width="330" />
      </div>
    </div>
    <div class="mt-4 grid gap-4 items-center" style="grid-template-columns: 1fr 1fr">
      <div>
        <div class="content-label">4.1 사고 부위</div>
        <page-chart-table :data-list="chartData.사고_부위데이터" :total="chartData.사고_부위인원" />
      </div>
      <div>
        <BasicPieChart :value="chartData.사고_부위데이터"
                       labelField="구분" valueField="점유율" :height="150"
                       :show-data-labels="false" :legend-width="330" />
      </div>
    </div>
    <div class="mt-4 grid gap-4 items-center" style="grid-template-columns: 1fr 1fr">
      <div>
        <div class="content-label">5. 육체적 부담 정도</div>
        <page-chart-table :data-list="chartData.육체적부담정도데이터" :total="chartData.육체적부담정도인원" />
      </div>
      <div>
        <BasicPieChart :value="chartData.육체적부담정도데이터"
                       labelField="구분" valueField="점유율" :height="150"
                       :show-data-labels="false" :legend-width="330" />
      </div>
    </div>

    <div class="mt-4 grid gap-4 items-center" style="grid-template-columns: 1fr 1fr">
      <div>
        <div class="content-label">6. 근골증상여부</div>
        <page-chart-table :data-list="chartData.근골증상여부데이터" :total="chartData.근골증상여부인원" />
      </div>
      <div>
        <BasicPieChart :value="chartData.근골증상여부데이터"
                       labelField="구분" valueField="점유율" :height="150"
                       :show-data-labels="false" :legend-width="330" />
      </div>
    </div>

    <div class="mt-4 grid gap-4 items-center" style="grid-template-columns: 1.5fr 1fr">
      <div>
        <div class="content-label">6.2 통증 지속 기간</div>
        <page-chart-table-symptom
          :data-list="chartData.근골증상_통증지속시간데이터"
          :columnTypes="getChartResultType('근골증상_통증지속시간')" />
      </div>
      <div>
        <symptom-bar-chart
          :series="chartData.통증지속시간차트데이터.series"
          :categories="chartData.통증지속시간차트데이터.categories" :height="280" />

      </div>
    </div>

    <div class="mt-4 grid gap-4 items-center" style="grid-template-columns: 1.5fr 1fr">
      <div>
        <div class="content-label">6.3 통증 정도</div>
        <page-chart-table-symptom
          :data-list="chartData.근골증상_통증정도데이터"
          :columnTypes="getChartResultType('근골증상_통증정도')" />
      </div>
      <div>
        <symptom-bar-chart
          :series="chartData.통증정도차트데이터.series"
          :categories="chartData.통증정도차트데이터.categories" :height="280" />

      </div>
    </div>

    <div class="mt-4 grid gap-4 items-center" style="grid-template-columns: 1.5fr 1fr">
      <div>
        <div class="content-label">6.4 통증 빈도</div>
        <page-chart-table-symptom
          :data-list="chartData.근골증상_통증빈도데이터"
          :columnTypes="getChartResultType('근골증상_통증빈도')" />
      </div>
      <div>
        <symptom-bar-chart
          :series="chartData.통증빈도차트데이터.series"
          :categories="chartData.통증빈도차트데이터.categories" :height="280" />

      </div>
    </div>

    <div class="mt-4 grid gap-4 items-center" style="grid-template-columns: 1.5fr 1fr">
      <div>
        <div class="content-label">6.5 지난 1주일 증상 여부</div>
        <page-chart-table-symptom
          :data-list="chartData.근골증상_지난1주일증상여부데이터"
          :columnTypes="getChartResultType('근골증상_지난1주일증상여부')" />
      </div>
      <div>
        <symptom-bar-chart
          :series="chartData.지난1주일증상여부차트데이터.series"
          :categories="chartData.지난1주일증상여부차트데이터.categories" :height="280" />

      </div>
    </div>

    <div class="mt-4 grid gap-4 items-center" style="grid-template-columns: 1.5fr 1fr">
      <div>
        <div class="content-label">6.6 통증으로 인해 일어난 일</div>
        <page-chart-table-symptom
          :data-list="chartData.근골증상_통증으로인해일어난일데이터"
          :columnTypes="getChartResultType('근골증상_통증으로인해일어난일')" />
      </div>
      <div>
        <symptom-bar-chart
          :series="chartData.통증으로인해일어난일차트데이터.series"
          :categories="chartData.통증으로인해일어난일차트데이터.categories" :height="280" />

      </div>
    </div>

    <div class="mt-4 grid gap-4 items-center" style="grid-template-columns: 1fr 1fr">
      <div>
        <div class="content-label">6.7 근골격계질환자 추정</div>
        <page-chart-table :data-list="chartData.근골증상_근골격계질환자추정데이터" :total="chartData.근골증상_근골격계질환자추정인원" />
      </div>
      <div>
        <BasicPieChart :value="chartData.근골증상_근골격계질환자추정데이터"
                       labelField="구분" valueField="점유율" :height="150"
                       :show-data-labels="false" :legend-width="330" />
      </div>
    </div>

  </div>
</template>

<script>
import PageChartTable from "@/views/boards/single-page/471/page_chart_table.vue";
import BasicPieChart from "@/components/BasicPieChart.vue";
import PageChartTableSymptom from "@/views/boards/single-page/471/page_chart_table_symptom.vue";
import SymptomBarChart from "@/components/SymptomBarChart.vue";

export default {
  name: "Print471",
  components: {SymptomBarChart, PageChartTableSymptom, BasicPieChart, PageChartTable},
  props: {
    form: Object,
    board: Object,
    chartData: Object,
  },
  methods: {
    getChartResultType(category) {
      switch (category) {
        case "성별":
          return ["남", "여"];
        case "결혼여부":
          return ["기혼", "미혼"];
        case "여가및취미활동":
          return ["게임 등 컴퓨터 관련 활동", "아노, 드럼펫 등 악기연주", "뜨개질, 붓글씨 등", "테니스, 축구, 농구, 골프 등 스포츠 활동", "해당사항 없음"];
        case "하루평균가사노동시간":
          return ["거의 하지 않는다", "1시간 미만", "1-2시간 미만", "2-3시간 미만", "3시간 이상"];
        case "질병진단여부":
          return ["예", "아니오"];
        case "질병_현재상태":
          return ["완치", "치료나 관찰중"];
        case "질병_질병명":
          return ["류머티스 관절염", "당뇨병", "통풍", "알코올중독", "해당사항 없음"];
        case "사고여부":
          return ["예", "아니오"];
        case "사고_부위":
          return ["손/손가락/손목", "팔/팔꿈치", "어깨", "목", "허리", "다리/발"];
        case "육체적부담정도":
          return ["전혀 힘들지 않음", "견딜만 함", "약간 힘듦", "힘듦", "매우 힘듦"];
        case "근골증상여부":
          return ["예", "아니오"];
        case "근골증상_구분":
          return ["목", "어깨", "팔/팔꿈치", "손/손가락/손목", "허리", "다리/발"];
        case "근골증상_통증지속시간":
          return ["1일 미만", "1일 - 1주일 미만", "1주일 - 1달 미만", "1달 - 6개월 미만", "6개월 이상"];
        case "근골증상_통증정도":
          return ["약한 통증", "중간 통증", "심한 통증", "매우 심한 통증"];
        case "근골증상_통증빈도":
          return ["6개월에 1번", "2-3달에 1번", "1달에 1번", "1주일에 1번", "매일"];
        case "근골증상_지난1주일증상여부":
          return ["아니오", "예"];
        case "근골증상_통증으로인해일어난일":
          return ["병원, 한의원 치료", "약국치료", "병가, 산재", "작업 전환", "해당사항 없음"];
        case "근골증상_근골격계질환자추정":
          return ["정상", "관리대상자", "통증호소자"];
        default:
          return [];
      }
    },
  }
}
</script>

<style lang="scss" scoped>

.header {
  font-size: 24px;
  font-weight: bold;
  color: #000;
  text-align: center;
  padding: 4px 0;
}
.sub-header {
  font-weight: 500;
  font-size: 20px;
  text-align: center;
}
.content-label {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 10px;
}

table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;

  th,
  td {
    border: 1px solid #cdcdcd;
    padding: 10px 7px;
  }

  th,
  tr.avg td {
    font-size: 14px;
    font-weight: 500;
    text-align: center;

    background: #f9f9f9;
  }
  td {
    font-size: 14px;
    font-weight: 400;
    text-align: center;

    background: white;
  }
}

.print-container {
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
}


/* 인쇄 시 적용될 스타일 */
@media print {
  .print-container {
    position: absolute !important;
    left: 0 !important;
    top: 0 !important;
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    max-width: 100%;
  }

  .vs-card {
    box-shadow: none !important;
    border: 1px solid #eee;
    margin-bottom: 10px !important;
    padding: 0 !important;
  }

  /* 테이블이 인쇄 영역을 벗어나지 않도록 설정 */
  table {
    width: 100% !important;
    max-width: 100% !important;
    font-size: 12px !important;
  }

  /* 차트 크기 최적화 */
  .responsive-grid {
    grid-template-columns: 1fr 1fr !important;
  }

  @page {
    size: A4;
    margin: 10mm;
  }
}


h5 {
  font-size: 16px;
  font-weight: 500;
  color: #3c3c3c;
}

.responsive-grid {
  display: grid;
  grid-template-columns: 1.8fr 1.2fr;
  gap: 15px;
  align-items: center;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
}

/* 페이지 내 여백 조정 */
.p-2 {
  padding: 0.5rem !important;
}

.mb-4 {
  margin-bottom: 0.5rem !important;
}

/* 카드 간격 조정 */
.w-full {
  margin-bottom: 10px;
}
</style>
